export default {"src":"/_next/static/media/aboutcorporatebg.43336f2f.gif","height":777,"width":864,"blurWidth":0,"blurHeight":0};